import { store } from '@betacrew/jars-flux'
import { put, takeEvery, all, call, takeLatest } from 'redux-saga/effects';
import { componentKey, setLoadingState, setQRCode } from './TwoFactorAuthenticationSlice';
import UserDataService from '../../../../services/UserDataService';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { GENERIC_ERROR_MESSAGE, PAGE_STATE } from '../../constants/constants';
import { setTwoFA } from '../../authentication/AuthenticationSlice';
import { TFA_STATE } from './constant';

export const { getQRCode, disableTFA, verifyTFACode } = {
    getQRCode: (payload) => {
        return {
            type: "TWOFA/GET_QR_CODE",
            payload: payload
        }
    },
    verifyTFACode: (payload) => {
        return {
            type: "TWOFA/VERIFY_TWO_CODE",
            payload: payload
        }
    },
    disableTFA: (payload) => {
        return {
            type: "TWOFA/DISABLE",
            payload: payload
        }
    }
}

function* getQRCodeAsync() {
    try {
        yield put(setLoadingState({ state: TFA_STATE.LOADING }))
        const response = yield UserDataService.getQRCode();
        if (response?.data?.Status) {
            if(response.data?.Data?.qrImageUrl){
                yield put(setQRCode(response.data?.Data?.qrImageUrl));
            }
        }else{
            yield put(setTwoFA(true))
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: GENERIC_ERROR_MESSAGE,
        }));
    } finally {
        yield put(setLoadingState({ state: TFA_STATE.PAGE_READY }))
    }
}

function* verifyTFACodeAsync(action) {
    try {
        yield put(setLoadingState({ state: TFA_STATE.LOADING }))
        const response = yield UserDataService.verifyTFACode(action.payload);
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(addNotifications({
                heading: "Success",
                message: response.data?.Message ?? "",
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield put(setTwoFA(true))
        } else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message ?? "",
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: GENERIC_ERROR_MESSAGE,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: TFA_STATE.PAGE_READY }))
    }
}

function* disableTFAAsync() {
    try {
        yield put(setLoadingState({ state: TFA_STATE.LOADING }))
        const response = yield UserDataService.DisableTFA();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(addNotifications({
                heading: "Success",
                message: response.data?.Message ?? "",
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield put(setTwoFA(false))
        } else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data?.Message ?? "",
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: GENERIC_ERROR_MESSAGE
        }));
    } finally {
        yield put(setLoadingState({ state: TFA_STATE.PAGE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getQRCode().type, getQRCodeAsync),
        takeLatest(verifyTFACode().type, verifyTFACodeAsync),
        takeLatest(disableTFA().type, disableTFAAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);